import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import cognitoService from './cognito';

// HTTP link to GraphQL endpoint
const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_ENDPOINT || 'https://api.work-it.com.ar/graphql',
  credentials: 'omit',
});

// Auth link to add Cognito JWT token to requests
const authLink = setContext(async (_, { headers }) => {
  // Get the authentication token from Cognito service
  const token = cognitoService.getIdToken(); // Use ID token for GraphQL

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

// Configure cache with proper type policies to prevent data loss
const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // These array fields should be completely replaced, not merged
        getAllActiveSessions: {
          merge(_existing, incoming) {
            return incoming; // Always use fresh data
          },
        },
        getActiveSessionsForParking: {
          merge(_existing, incoming) {
            return incoming; // Always use fresh data
          },
        },
        getAllSlotsTelemetry: {
          merge(_existing, incoming) {
            return incoming;
          },
        },
        getSlotsTelemetry: {
          merge(_existing, incoming) {
            return incoming;
          },
        },
        getAllLocations: {
          merge(_existing, incoming) {
            return incoming;
          },
        },
      },
    },
  },
});

// Combine auth link and http link
export const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
});
